module.exports = __webpack_public_path__ + "img/bitmine.d0d2873d.png";